/**
 * @module core/aem
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

// Core Libraries
import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { DynamicModal } from '@support/shared/widgets/interfaces/dynamic-modal.interface';
import { BrowsePlanConfig } from '@core/aem/interfaces/shop/browse-plan.interface';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'tmo-tourist-plan-conflict-modal',
  templateUrl: './tourist-plan-conflict-modal.component.html',
  styleUrls: [],
})
export class TouristPlanConflictModalComponent implements OnInit, OnDestroy {
  /**
   * Stores show/hide boolean value for modal
   */
  public displayModal: Boolean;
  /**
   * Stores the content coming from AEM call
   */
  @Input() public staticContent: BrowsePlanConfig;
  /**
   * check if byos flow
   */
  @Input() public isByos: boolean;
  /**
   * check if testDrive plan in cart
   */
  @Input() public isTestDrivePlan: boolean;
  /**
   * check if coming from Plan flow
   */
  @Input() public isPlan: boolean;
  /**
   * Event Emitter to trigger events on clicking standalone device
   * @type {EventEmitter<boolean>}
   * @memberof touristConflictModalComponent
   */
  @Output() public addStandAloneDevice: EventEmitter<boolean>;
  /**
   * To create the modal
   */
  public modal: DynamicModal;

  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute
  ) {
    this.addStandAloneDevice = new EventEmitter<boolean>();
    this.modal = {
      disableDismiss: false,
      disableEsc: true,
      toggleModalEmitter: new EventEmitter(),
      dismissableMask: true,
      modalName: 'tourist-plan-conflict-modal',
    };
  }

  /**
   * loads the initial state of product offerings component
   * @returns void
   */
  public ngOnInit(): void {
    this.displayModal = true;
  }

  /**
   * Method used to destroy data, subscriptions
   * @returns void
   */
  public ngOnDestroy(): void {}

  /**
   * navigate to cart if user select to go with current cart
   * @returns void
   */
  public goToCurrentCartSelection(): void {
    this.router.navigate(['/cart']);
  }

  /**
   * navigate to product selector if user select Standalone device
   * @returns void
   */
  public selectStandaloneDevice(): void {
    this.addStandAloneDevice.emit(true);
  }

  /**
   * emit addStandAloneDevice to false
   * @returns void
   */
  public closeModal(): void {
    this.addStandAloneDevice.emit(false);
  }
}
